/*
 * @Author: wonderswang
 * @Date: 2023-4-26 15:18:25
 * @LastEditTime: 2025-01-15 21:57:10
 * @LastEditors: juanjualong juanjualong@tencent.com
 * @Description: 此文件仅在renderer进程加载,由于加载顺序的问题，这里只包含非中文的设置，包含语言翻译的设置请前往ConstantI18NConfig.ts
 * @FilePath: /smh-drive-client/src/common/constant/index.ts
 */

import {
  IS_BROWSER,
  IS_PC_IN_MAC,
  IS_BROWSER_IN_ANDROID,
  IS_BROWSER_IN_IOS,
  IS_BROWSER_IN_OTHER_MOBILE,
  IS_PC_IN_M1_MAC,
  IS_PC_IN_ARM_LINUX,
  IS_PC_IN_LINUX,
  IS_PC_IN_WIN,
  IS_BROWSER_IN_TENCENT_APP,
} from '@/common/constant/platform';
import { windowEnvs } from '@/renderer/scripts/utils/ConstantConfig/PrivateConfig';

// 获取访问渠道
const sourceChannel: string = (function sourceChannel() {
  if (IS_BROWSER) {
    if (IS_BROWSER_IN_ANDROID) return 'android';
    if (IS_BROWSER_IN_IOS) return 'ios';
    if (IS_BROWSER_IN_OTHER_MOBILE) return 'mobile_browser';
    return 'browser';
  }
  if (IS_PC_IN_MAC) {
    if (IS_PC_IN_M1_MAC) return 'mac_m1';
    return 'mac';
  }
  if (IS_PC_IN_LINUX) {
    if (IS_PC_IN_ARM_LINUX) return 'linux_arm64';
    return 'linux';
  }
  if (IS_PC_IN_WIN) return 'win';
  return 'unknown';
})();

// 是否在微信、企微内置浏览器里
export const inWeBrowser: boolean = IS_BROWSER_IN_TENCENT_APP;

export enum RoleMap {
  User = 'User',
  TeamAdmin = 'TeamAdmin',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
}
const sizeMap: {
  [key: string]: number;
} = {
  B: 1,
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
  TB: 1024 * 1024 * 1024 * 1024,
  PB: 1024 * 1024 * 1024 * 1024 * 1024,
  EB: 1024 * 1024 * 1024 * 1024 * 1024 * 1024,
};

// 付费套餐计划
export const PAY_PLAN_MAP = {
  // 个人版
  Personal: 'personal',
  // 小团队版
  Team: 'team',
  // 企业版
  EnterPrise: 'enterprise',
};
export const COLOR_GROUP = ['#FFF4E3', '#DEEAFF', '#D3F7E7'];
export const TEXT_COLOR_GROUP = ['#FFA200', '#0444D9', '#00B264'];

export default {
  sourceChannel,
  RoleMap,
  sizeMap,
  // 企业名称字数限制
  orgNameMaxLength: 24,
  // 团队名称字数限制
  teamNameMaxLength: 64,
  // 用户昵称字数限制
  nicknameMaxLength: 100,
  // 用户备注字数限制
  commentMaxLength: 200,
  // 用户头像上传最大限制 KB
  userAvatarMaxSize: 5 * sizeMap.KB,
  // 右上角hover时查询个人空间，间隔60s后请求查询
  querySpaceInterval: 60 * 1000,
  // 预览界面，轮播图加载文件的pageSize
  previewPageSize: 20,
  // 预览界面，ci支持的最大文件大小 32mb
  ciImageMaxSize: 32 * sizeMap.MB,
  // 预览界面，编辑支持的最大文件大小 4mb
  editMaxSize: 4 * sizeMap.MB,
  // 默认设置团队空间大小为1GB,避免出现切换时出现大小为0
  defaultTeamSpaceSize: 1 * sizeMap.GB,
  // 默认设置个人空间大小为100MB,避免出现切换时出现大小为0
  defaultPersonalSpaceSize: 100 * sizeMap.MB,
  esignFileMaxSize: 60 * sizeMap.MB,
  // 是否允许手机号登录（无，则不显示临时成员入口等）
  allowPhoneLogin: windowEnvs.loginMainEntrance.includes('loginWithPhone'),
  // 是否只支持账密登录
  onlyPasswordLogin: windowEnvs.onlyPasswordLogin,
  // 登录前是否需要先选组织机构
  selectOrgBeforeLogin: windowEnvs.selectOrgBeforeLogin,
  // 个人空间最小限制,创建用户会自动下发操作手册占用空间
  minPersonalSpaceSize: 100 * 1024 * 1024,
  // 群组名称字数限制
  groupNameMaxLength: 64,
  // 新建文件字数限制
  fileNameMaxLength: 200,
  // 文件上传/下载数量限制
  FILE_COUNT_LIMIT: 300000,
};

export const FILE_MANAGE_ROUTE_LIST = [
  'desktop',
  'workbench',
  'favoriteList',
  'personalSpace',
  'collaborationSpace',
  'collaborationSpaceList',
  'collaborationShareList',
  'teamSpace',
  'recycleBin',
  'relatedToMe',
  'relatedToMeFileList',
  'fileApply',
  'receivedShare',
  'linkManage',
  'myFavorite',
  'recentUse',
  'fileSync',
  'message',
  'electronicSign',
  'suspiciousFile',
  'search',
  'fileCollect',
];

export interface TransferSetting {
  chunkParallelLimit: number;
  batchLimit: number;
  retryLimit: number;
}

// 传输列表默认配置项
export const TRANSFER_LIMIT = {
  download: {
    // 分块数量限制
    chunkParallelLimit: 5,
    // 文件上传限制
    batchLimit: 5,
    // 重试限制
    retryLimit: 5,
  },
  upload: {
    // 分块数量限制
    chunkParallelLimit: 5,
    // 文件上传限制
    batchLimit: IS_BROWSER ? 2 : 5, // 上传文件的并发 web为2，electron为5,
    // 重试限制
    retryLimit: 5,
  },
};
